import { render, staticRenderFns } from "./notification-detail.page.vue?vue&type=template&id=9c3df856&scoped=true&"
import script from "./notification-detail.page.vue?vue&type=script&lang=js&"
export * from "./notification-detail.page.vue?vue&type=script&lang=js&"
import style0 from "./notification-detail.page.vue?vue&type=style&index=0&id=9c3df856&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c3df856",
  null
  
)

export default component.exports